import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SpinnerService {
  public visibility: Subject<boolean> = new Subject<boolean>();
}
